export const formatSeparator = (separator: string) => {
  switch (separator) {
    case '\\t': {
      return '\t';
    }
    default: {
      return separator;
    }
  }
};
